import React, { useEffect } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import Home from './routes/Home';
import Share from './routes/Share';
import ShareEmbed from './routes/ShareEmbed';
import Myhome from './routes/Myhome';
import LoginProvider from './components/LoginProvider';
import LangProvider from './components/LangProvider';
import { initializeLocalStorage } from './utils/loadAndSaveData';

function App(props) {
  useEffect(() => {
    // 앱 시작 시 localStorage 상태 체크 및 자동 복구
    initializeLocalStorage();
  }, []);

  return (
    <LangProvider>
      <LoginProvider>
        <Router>
            <Switch>
              <Route exact path='/home' component={Home} />
              <Route exact path="/share" component={Share} />
              <Route path="/share/:bookTitle" component={ShareEmbed} />
              <Route path="/:pathUserid?/:pathTitle?" component={Myhome} />
            </Switch>
        </Router>
      </LoginProvider>
    </LangProvider>
  );
}
export default App;
